import React, { useState, useEffect, useReducer, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGroupClassificationAction } from "../actions";
import { getLoading, getData } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import paths from "@icarius-router/paths";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import { reducer, initialState } from "../reducer";
import MembersDialog from "./groupsDialog";
import { getLocalizedString } from "@icarius-localization/strings";

const GroupClassification = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);
    const [state, dispatchLocalReducer] = useReducer(reducer, initialState);

    const dispatch = useDispatch();

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getGroupClassificationAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.organizationalDefinitions);
    };

    const handleOpenMembersDialog = useCallback(
        (group) => dispatchLocalReducer({ type: "OPEN_MEMBERS_DIALOG", payload: group }),
        []
    );
    const handleCloseMembersDialog = () => dispatchLocalReducer({ type: "CLOSE_MEMBERS_DIALOG" });

    return (
        <ABMLayout
            title={getLocalizedString("groupClassification")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("newGroupClassification")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noGroupClassificationsFound")}
            noDataCreateTitle={getLocalizedString("newGroupClassification")}
            noDataOnClick={() => setCreateIsOpen(true)}
        >
            {state.membersDialogIsOpen && (
                <MembersDialog
                    open={state.membersDialogIsOpen}
                    groups={state.selectedGroup?.associatedGroups || []}
                    handleClose={handleCloseMembersDialog}
                />
            )}
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem color={color} data={null} closeNew={() => setCreateIsOpen(false)} />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
                            <DataItem data={item} color={color} handleOpenMembersDialog={handleOpenMembersDialog} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default GroupClassification;
